module.exports = __webpack_public_path__ + "static/media/contest2025_first_place_profileImage.70d5ae0b.jpeg";